module.exports = "/_next/static/images/d781a5264fbb18878000f419f39cfbb9-press-media-desktop.jpg.webp";